import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_LIST_FETCH_FOR_OFFICE } from '../../constants/doctorTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorListSchema } from '../../schemas/Normalizr';

export function* doctorListFetchForOffice(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(DOCTOR_LIST_FETCH_FOR_OFFICE, call(doctorAPI.allForOffice, params), doctorListSchema);
  } catch (e) {
    yield put(error(DOCTOR_LIST_FETCH_FOR_OFFICE, e));
  } finally {
    yield put(doneIndicator(DOCTOR_LIST_FETCH_FOR_OFFICE));
  }
}

export function* watchDoctorListFetchForOffice() {
  yield takeEvery(DOCTOR_LIST_FETCH_FOR_OFFICE, doctorListFetchForOffice);
}

export default function* root() {
  yield all([
    fork(watchDoctorListFetchForOffice)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorListFetchForOffice.js